import React from 'react';
import { useWatch } from 'react-hook-form';
import { DNumberField } from '../../../../../../../dum';
import { IOrderSale } from '../../order-sale-form';
import { useReturnTotals } from './use-return-totals';

const noop = () => undefined;

const NET_TOTAL_LABEL = 'Total neto (menos devoluciones)';

// Read-only value of one returned line (IVA included).
export function ReturnLineTotal({ index }: { index: number }) {
    const { lineValues } = useReturnTotals();
    return (
        <DNumberField
            value={lineValues[index] ?? 0}
            onChange={noop}
            label={'Total (IVA incl.)'}
            disabled
            disableGutters
        />
    );
}

// Read-only totals under the Devoluciones tab: what was returned and what the
// client still owes for the sale after the returns.
export function ReturnTotals() {
    const { total, netTotalWithTax } = useReturnTotals();
    return (
        <>
            <DNumberField
                value={total}
                onChange={noop}
                label={'Total devolución (IVA incl.)'}
                disabled
            />
            <DNumberField
                value={netTotalWithTax}
                onChange={noop}
                label={NET_TOTAL_LABEL}
                disabled
            />
        </>
    );
}

// Same net total, shown under the Productos tab's Total so the amount the
// client actually owes is visible without switching tabs. Hidden when the sale
// has no returns — the net would just repeat the Total above it.
export function NetTotal() {
    const { netTotalWithTax } = useReturnTotals();
    const orderAdjustmentProducts = useWatch({
        name: 'order_adjustment_products',
    }) as IOrderSale['order_adjustment_products'];
    if (!orderAdjustmentProducts?.length) return null;
    return (
        <DNumberField
            value={netTotalWithTax}
            onChange={noop}
            label={NET_TOTAL_LABEL}
            disabled
        />
    );
}
